import React from "react";
import { AutopayOnIcon, Box, Cluster, Text, Tooltip } from "@thecb/components";
import { formatDate } from "/util/dateUtil";
import { CHARADE_GREY, SEA_GREEN, WHITE } from "/constants/colors";

const TransactionDate = ({
  id,
  createdAt,
  fontSize,
  paymentInitiatorDetails
}) => {
  const isAutopayEnabled = paymentInitiatorDetails?.isAutoInitiated;
  const popoverID = `transaction-history-date-${id}`;
  const displayText = formatDate(createdAt);

  return isAutopayEnabled ? (
    <Tooltip
      hasCustomTrigger
      tooltipID={popoverID}
      containerExtraStyles={`min-width: 100px; overflow: visible;  cursor: pointer; button, button span {color: ${SEA_GREEN}; button:hover span {color: ${SEA_GREEN};`}
      maxWidth="none"
      minWidth="0"
      contentExtraStyles={`white-space: nowrap; width: max-content; padding: 0.5rem; background-color: ${SEA_GREEN}; color: ${WHITE}; transform: translateX(-50%); span {font-size: ${fontSize}; color: ${WHITE};}`}
      content="Automatic Payment"
      backgroundColor={SEA_GREEN}
      contentPosition={{
        top: "auto",
        left: "0",
        right: "auto",
        bottom: "calc(100% + 10px)"
      }}
      arrowPosition={{
        arrowTop: "auto",
        arrowRight: "auto",
        arrowBottom: "-8px",
        arrowLeft: "calc(50% - 8px)"
      }}
    >
      <Box padding="0" extraStyles="white-space: nowrap; min-width: 100px;">
        <AutopayOnIcon />
        <Text
          fontSize={fontSize}
          color={SEA_GREEN}
          extraStyles="margin-left: 5px; white-space: nowrap;"
        >
          {displayText}
        </Text>
      </Box>
    </Tooltip>
  ) : (
    <Cluster childGap={"5px"} align="center">
      <Text color={CHARADE_GREY} fontSize={fontSize}>
        {displayText}
      </Text>
    </Cluster>
  );
};

export default TransactionDate;
